import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { CanPipe } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import {
  AlertComponent,
  InputLabelComponent,
  LoaderComponent,
  RadioComponent,
  RadioDescription,
  SelectComponent,
  TextEllipsisComponent
} from 'mbs-ui-kit';
import { SelectLicenseFormComponent } from 'mbs-ui-shared@components/select-license-form/select-license-form.component';
import { LicenseType } from 'mbs-ui-shared@models';

@Component({
  selector: 'mbs-select-license-form-extended',
  templateUrl: '../select-license-form/select-license-form.component.html',
  standalone: true,
  imports: [
    DatePipe,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    TextEllipsisComponent,
    LoaderComponent,
    CanPipe,
    AlertComponent,
    InputLabelComponent,
    I18NextPipe,
    SelectComponent,
    RadioComponent,
    RadioDescription
  ]
})
export class SelectLicenseFormExtendedComponent extends SelectLicenseFormComponent {
  userId = input<string>();

  constructor() {
    super();
  }

  protected override getSupportedLicenseTypesParams() {
    return { hid: this.hid(), kind: this.kind(), companyId: this.companyId(), userId: this.userId() };
  }

  protected override getGetAvailablePaidLicensesRequest(licenseType: LicenseType) {
    return this.licensesService.getAvailablePaidLicensesByCompanyId({
      hid: this.hid(),
      licenseTypeIds: [licenseType],
      companyId: this.companyId(),
      userId: this.userId()
    });
  }

  protected override getGetAvailableLicensesRequest(licenseType: LicenseType) {
    return this.licensesService.getAvailableLicensesByCompanyId(this.hid(), licenseType, this.companyId(), this.userId());
  }
}
